export default __webpack_public_path__ + "static/media/contactsBlue.08a9dafd.svg";